import { go, html, strMap } from 'fxjs/es';
import { NessCustomMakerFrameShareTmplS } from '../../../../../NessCustomMaker/Frame/Share/S/Tmpl/module/NessCustomMakerFrameShareTmplS.js';
import { NessLabsSettingS } from '../../../S/Function/module/NessLabsSettingS.js';

export const motion = ({ type, value, motions, is_frame_select }) => {
  return `<div class = "options" data-type="${type}">
    ${NessCustomMakerFrameShareTmplS.iscroll_wrapper_tmpl(
      go(
        motions,
        strMap((option) => {
          const { name, motion_id } = option;
          const display_name = NessLabsSettingS.numberToLetter(option);
          return is_frame_select
            ? html` <li
                class="option selector_item i_item ${value == option ? 'selected' : ''}"
                data-name="${display_name}"
                data-value="${option}"
                data-frame_option="${option}"
              >
                ${display_name}
              </li>`
            : html`
                <li
                  class="option selector_item i_item ${value === motion_id ? 'selected' : ''}"
                  data-name="${name}"
                  data-value="${motion_id}"
                >
                  ${name}
                </li>
              `;
        }),
      ),
      {
        offsetY: 0,
      },
    )}</div>`;
};
